/** Leaf SSOT — bulk/finance handler ref constants (no upstream workbench imports). */

export const BULK_STATE_CHANGE_HANDLER_REFS = {
  activate: 'bulk:status:active',
  archive: 'bulk:status:archive',
  delete: 'bulk:delete',
} as const;

export const FINANCE_COMPENSATING_PREFIX = 'finance:reversal:' as const;
